// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A4 Load Confirmation document — shared by live preview and PDF export */

.lc-document-root {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11px;
  line-height: 1.35;
  color: #1a1a1a;
  box-sizing: border-box;
  --lc-grid-cols: 1fr 1fr 1fr;
  --lc-grid-gap: 12px;
  --lc-page-padding-x: 16mm;
  --lc-page-padding-y: 14mm;
}

.lc-document-root *,
.lc-document-root *::before,
.lc-document-root *::after {
  box-sizing: border-box;
}

.lc-a4-page {
  width: 210mm;
  min-height: 297mm;
  height: 297mm;
  padding: var(--lc-page-padding-y) var(--lc-page-padding-x);
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  page-break-after: always;
  break-after: page;
}

.lc-page-body {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.lc-blue {
  color: #1a4f9c;
}

.lc-bold {
  font-weight: 700;
}

/* ── Full header (page 1) ── */
.lc-header-full {
  display: grid;
  grid-template-columns: var(--lc-grid-cols);
  gap: var(--lc-grid-gap);
  align-items: start;
  margin-bottom: 8px;
}

.lc-logo-wrap {
  margin-bottom: 4px;
}

.lc-logo-img {
  display: block;
  max-width: 150px;
  max-height: 92px;
  object-fit: contain;
  object-position: left top;
  margin-bottom: 4px;
}

.lc-company-name {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 2px;
}

.lc-header-center {
  font-size: 10px;
  line-height: 1.45;
}

.lc-header-center .lc-label {
  font-weight: 700;
}

.lc-header-right {
  text-align: left;
}

.lc-doc-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a4f9c;
  line-height: 1.1;
}

.lc-load-number {
  font-size: 18px;
  font-weight: 700;
  color: #1a4f9c;
  margin-top: 4px;
}

/* ── Mini header (page 2+) ── */
.lc-header-mini {
  padding: 6px 0;
  margin: 0 0 8px;
  font-weight: 700;
  font-size: 12px;
}

/* ── Carrier section ── */
.lc-section-title {
  color: #1a4f9c;
  font-weight: 700;
  font-size: 12px;
  margin: 4px 0 2px;
}

.lc-rule {
  border: none;
  border-top: 1px solid #333;
  margin: 4px 0 6px;
}

.lc-carrier-grid {
  display: grid;
  grid-template-columns: var(--lc-grid-cols);
  gap: var(--lc-grid-gap);
  font-size: 10.5px;
  margin-bottom: 8px;
  align-items: start;
}

.lc-carrier-grid .lc-field-label {
  font-weight: 700;
}

/* ── Stop blocks (Shipper / Consignee) ── */
.lc-stop-block {
  margin-bottom: 10px;
  page-break-inside: avoid;
  break-inside: avoid;
}

.lc-stop-grid {
  display: grid;
  grid-template-columns: var(--lc-grid-cols);
  gap: var(--lc-grid-gap);
  align-items: start;
  font-size: 10.5px;
}

.lc-stop-head {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.lc-stop-number {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  flex-shrink: 0;
  min-width: 12px;
  padding-top: 0;
}

.lc-stop-details {
  min-width: 0;
}

.lc-stop-name {
  font-weight: 700;
  font-size: 11px;
  margin-bottom: 2px;
}

.lc-stop-col-meta .lc-meta-row {
  margin-bottom: 2px;
}

.lc-stop-col-meta .lc-meta-label,
.lc-field-label {
  font-weight: 700;
}

.lc-stop-col-schedule {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lc-schedule-line {
  display: block;
  line-height: 1.35;
}

.lc-stop-col-schedule .lc-date {
  color: #1a4f9c;
  font-weight: 700;
}

.lc-stop-col-schedule .lc-time {
  font-weight: 700;
  font-size: 12px;
}

.lc-pickup-num {
  color: #1a4f9c;
  font-weight: 700;
}

.lc-stop-notes-full {
  margin-top: 8px;
  font-size: 10px;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.lc-stop-notes-full > div:last-child {
  white-space: pre-wrap;
}

.lc-stop-notes-full .lc-notes-label {
  font-weight: 700;
  margin-bottom: 2px;
}

/* ── Notes section ── */
.lc-notes-section {
  margin-top: 8px;
  font-size: 10.5px;
  line-height: 1.5;
}

.lc-notes-section--continued {
  margin-top: 0;
}

.lc-notes-body {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}

/* ── Footer ── */
.lc-page-footer {
  flex-shrink: 0;
  margin-top: auto;
  padding-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #1a4f9c;
  font-weight: 700;
  border-top: 1px solid #ccc;
  background: #fff;
  position: relative;
  z-index: 1;
}

.lc-a4-page + .lc-a4-page {
  margin-top: 12px;
}

@media print {
  .lc-a4-page {
    margin: 0;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/load-confirmation/template/load-confirmation-template.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,0DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF","sourcesContent":["/* A4 Load Confirmation document — shared by live preview and PDF export */\n\n.lc-document-root {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #1a1a1a;\n  box-sizing: border-box;\n  --lc-grid-cols: 1fr 1fr 1fr;\n  --lc-grid-gap: 12px;\n  --lc-page-padding-x: 16mm;\n  --lc-page-padding-y: 14mm;\n}\n\n.lc-document-root *,\n.lc-document-root *::before,\n.lc-document-root *::after {\n  box-sizing: border-box;\n}\n\n.lc-a4-page {\n  width: 210mm;\n  min-height: 297mm;\n  height: 297mm;\n  padding: var(--lc-page-padding-y) var(--lc-page-padding-x);\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  page-break-after: always;\n  break-after: page;\n}\n\n.lc-page-body {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.lc-blue {\n  color: #1a4f9c;\n}\n\n.lc-bold {\n  font-weight: 700;\n}\n\n/* ── Full header (page 1) ── */\n.lc-header-full {\n  display: grid;\n  grid-template-columns: var(--lc-grid-cols);\n  gap: var(--lc-grid-gap);\n  align-items: start;\n  margin-bottom: 8px;\n}\n\n.lc-logo-wrap {\n  margin-bottom: 4px;\n}\n\n.lc-logo-img {\n  display: block;\n  max-width: 150px;\n  max-height: 92px;\n  object-fit: contain;\n  object-position: left top;\n  margin-bottom: 4px;\n}\n\n.lc-company-name {\n  font-weight: 700;\n  font-size: 12px;\n  margin-bottom: 2px;\n}\n\n.lc-header-center {\n  font-size: 10px;\n  line-height: 1.45;\n}\n\n.lc-header-center .lc-label {\n  font-weight: 700;\n}\n\n.lc-header-right {\n  text-align: left;\n}\n\n.lc-doc-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1a4f9c;\n  line-height: 1.1;\n}\n\n.lc-load-number {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a4f9c;\n  margin-top: 4px;\n}\n\n/* ── Mini header (page 2+) ── */\n.lc-header-mini {\n  padding: 6px 0;\n  margin: 0 0 8px;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n/* ── Carrier section ── */\n.lc-section-title {\n  color: #1a4f9c;\n  font-weight: 700;\n  font-size: 12px;\n  margin: 4px 0 2px;\n}\n\n.lc-rule {\n  border: none;\n  border-top: 1px solid #333;\n  margin: 4px 0 6px;\n}\n\n.lc-carrier-grid {\n  display: grid;\n  grid-template-columns: var(--lc-grid-cols);\n  gap: var(--lc-grid-gap);\n  font-size: 10.5px;\n  margin-bottom: 8px;\n  align-items: start;\n}\n\n.lc-carrier-grid .lc-field-label {\n  font-weight: 700;\n}\n\n/* ── Stop blocks (Shipper / Consignee) ── */\n.lc-stop-block {\n  margin-bottom: 10px;\n  page-break-inside: avoid;\n  break-inside: avoid;\n}\n\n.lc-stop-grid {\n  display: grid;\n  grid-template-columns: var(--lc-grid-cols);\n  gap: var(--lc-grid-gap);\n  align-items: start;\n  font-size: 10.5px;\n}\n\n.lc-stop-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.lc-stop-number {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n  flex-shrink: 0;\n  min-width: 12px;\n  padding-top: 0;\n}\n\n.lc-stop-details {\n  min-width: 0;\n}\n\n.lc-stop-name {\n  font-weight: 700;\n  font-size: 11px;\n  margin-bottom: 2px;\n}\n\n.lc-stop-col-meta .lc-meta-row {\n  margin-bottom: 2px;\n}\n\n.lc-stop-col-meta .lc-meta-label,\n.lc-field-label {\n  font-weight: 700;\n}\n\n.lc-stop-col-schedule {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lc-schedule-line {\n  display: block;\n  line-height: 1.35;\n}\n\n.lc-stop-col-schedule .lc-date {\n  color: #1a4f9c;\n  font-weight: 700;\n}\n\n.lc-stop-col-schedule .lc-time {\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.lc-pickup-num {\n  color: #1a4f9c;\n  font-weight: 700;\n}\n\n.lc-stop-notes-full {\n  margin-top: 8px;\n  font-size: 10px;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.lc-stop-notes-full > div:last-child {\n  white-space: pre-wrap;\n}\n\n.lc-stop-notes-full .lc-notes-label {\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n/* ── Notes section ── */\n.lc-notes-section {\n  margin-top: 8px;\n  font-size: 10.5px;\n  line-height: 1.5;\n}\n\n.lc-notes-section--continued {\n  margin-top: 0;\n}\n\n.lc-notes-body {\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n/* ── Footer ── */\n.lc-page-footer {\n  flex-shrink: 0;\n  margin-top: auto;\n  padding-top: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 11px;\n  color: #1a4f9c;\n  font-weight: 700;\n  border-top: 1px solid #ccc;\n  background: #fff;\n  position: relative;\n  z-index: 1;\n}\n\n.lc-a4-page + .lc-a4-page {\n  margin-top: 12px;\n}\n\n@media print {\n  .lc-a4-page {\n    margin: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
